import { Controller, useForm } from "react-hook-form";
import { AddBeneficiaries, sendOtp } from "../../services/beneficiaries";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Loading } from "../common/Loading";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { NumericFormat } from "react-number-format";
import { api, handleToast } from "../../services/config";
import { contextApi } from "../../context/contextApi";
import { useContext } from "react";
import { getAssetTypes, getWalletsByType } from "../../services/bags";

export const WalletFormRecive = ({ title }) => {
  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    formState: { errors },
  } = useForm();
  const [load, setLoad] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [assetTypes, setAssetTypes] = useState([]);
  const [filteredWallets, setFilteredWallets] = useState([]);
  const [defaultSet, setDefaultSet] = useState(false);
  const [walletDefaultSet, setWalletDefaultSet] = useState(false);
  const [inquiryDone, setInquiryDone] = useState(false);
  const context = useContext(contextApi);
  const [timer, setTimer] = useState(0);
  const [isDark, setIsDark] = useState(
    () =>
      typeof window !== "undefined" && document.body.classList.contains("dark"),
  );

  useEffect(() => {
    const checkDark = () => setIsDark(document.body.classList.contains("dark"));
    checkDark();
    const observer = new MutationObserver(() => {
      checkDark();
    });
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });
    return () => {
      observer.disconnect();
    };
  }, []);
  useEffect(() => {
    const storedStartTime = localStorage.getItem("startTime");
    // if (!storedStartTime) {
    //   const startTime = Math.floor(Date.now() / 1000);
    //   localStorage.setItem("startTime", startTime.toString());
    // }
    const currentTime = Math.floor(Date.now() / 1000);
    const elapsedTime = currentTime - parseInt(storedStartTime, 10);
    if (elapsedTime < 120) {
      setTimer(120 - elapsedTime);
    }
  }, []);

  useEffect(() => {
    const fetchAssetTypes = async () => {
      try {
        const res = await getAssetTypes();
        setAssetTypes(res?.data?.data ?? []);
      } catch (error) {
        setAssetTypes([]);
      }
    };
    fetchAssetTypes();
  }, []);

  useEffect(() => {
    const idFromQuery = searchParams.get("id");
    if (idFromQuery && assetTypes.length > 0 && !defaultSet) {
      const matchingType = assetTypes.find(
        (item) => item.type.toString() === idFromQuery
      );
      if (matchingType) {
        setValue("two", matchingType.type.toString());
        setDefaultSet(true);
      }
    }
  }, [assetTypes, searchParams, setValue, defaultSet]);

  const selectedWalletType = watch("two");
  useEffect(() => {
    const fetchWallets = async () => {
      if (selectedWalletType) {
        try {
          setValue("one", "");
          setFilteredWallets([]);
          const res = await getWalletsByType(selectedWalletType);
          const wallets = res?.data?.data ?? [];
          setFilteredWallets(wallets);

          const itemIdFromQuery = searchParams.get("itemId");
          if (itemIdFromQuery && !walletDefaultSet) {
            const matchingWallet = wallets.find(
              (item) => item.id.toString() === itemIdFromQuery
            );
            if (matchingWallet) {
              setValue("one", matchingWallet.id.toString());
            }
            setWalletDefaultSet(true);
          }
        } catch (error) {
          setFilteredWallets([]);
        }
      } else {
        setFilteredWallets([]);
        setValue("one", "");
      }
    };
    fetchWallets();
  }, [selectedWalletType, setValue]);

  const { state } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (!state) {
      navigate("/");
      return;
    }
  }, []);

  const onSubmit = async (data) => {
    const amount = +String(data.five).replace(/,/g, "");
    const mojodi = state?.amount != null ? parseInt(state.amount, 10) : null;

    if (mojodi != null && amount > mojodi) {
      handleToast("error", "مبلغ از موجودی حساب شما بیشتر است");
      return;
    }

    if (!inquiryDone) {
      handleToast("error", "لطفا ابتدا استعلام شبا را انجام دهید");
      return;
    }

    const formData = {
      otp: +data.six,
      asset_id: +data.one,
      amount: amount,
      des: "توضیحات",
      withdraw_type: "internal",
      internal_iban: data.four?.trim(),
    };

    try {
      await api.post("transactions/add-withdraw", formData, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          authorization: `Bearer ${localStorage.getItem("login")}`,
        },
      });
      handleToast("success", "درخواست برداشت ثبت گردید");
      setTimeout(() => {
        navigate("/");
      }, 3000);
    } catch (error) {
      console.log(error);
      const errors = error?.response?.data?.errors;
      const firstError =
        errors &&
        Object.values(errors)
          .flat()
          .find(Boolean);
      handleToast(
        "error",
        firstError || error?.response?.data?.message || "خطا در ثبت برداشت"
      );
    }
  };

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);

  const handlSendOTP = async () => {
    const typeWallet = watch("two");
    const walletName = watch("one");
    const walletAddress = watch("four");
    const destinationMobile = watch("mobile");
    const amount = watch("five");

    // چک کردن اینکه همه فیلدها پر شده باشند
    const missingFields = [];

    if (!typeWallet) {
      missingFields.push("نوع کیف پول");
    }
    if (!walletName) {
      missingFields.push("نام کیف پول");
    }
    if (!walletAddress || walletAddress.trim() === "") {
      missingFields.push("شبای کیف پول مقصد");
    }
    if (!destinationMobile || !/^9\d{9}$/.test(destinationMobile)) {
      missingFields.push("شماره موبایل مقصد");
    }
    if (!amount || amount === "" || amount === "0") {
      missingFields.push("مبلغ");
    }

    if (missingFields.length > 0) {
      handleToast("error", `لطفا ${missingFields.join("، ")} را وارد کنید`);
      return;
    }

    const startTime = Math.floor(Date.now() / 1000);
    localStorage.setItem("startTime", startTime.toString());
    setTimer(120);
    const bodyOtp = {
      mobile: localStorage.mobile, // در صورتی که کاربر وارد نشده بود
    };
    try {
      setLoad(true);
      await sendOtp(bodyOtp);
      handleToast("success", "کد ارسال شده را وارد کنید");
    } catch (error) {
      setTimer(0);
      localStorage.removeItem("startTime");
      handleToast("error", "خطا در ارسال کد تایید");
    }
    setTimeout(() => {
      setLoad(false);
    }, 500);
  };

  const handleInquiry = async () => {
    const internalIban = watch("four");
    const mobile = watch("mobile");

    if (!internalIban || internalIban.trim() === "") {
      handleToast("error", "لطفا شبای کیف پول مقصد را وارد کنید");
      return;
    }
    if (!mobile || !/^9\d{9}$/.test(mobile)) {
      handleToast("error", "لطفا شماره موبایل مقصد را به درستی وارد کنید");
      return;
    }

    try {
      setLoad(true);
      const response = await api.post(
        "internal-ibans/inquiry",
        {
          internal_iban: internalIban.trim(),
          mobile: Number(mobile),
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            authorization: `Bearer ${localStorage.getItem("login")}`,
          },
        }
      );
      const inquiryData = response?.data?.data;
      const customerName =
        inquiryData?.user?.customer_name ||
        `${inquiryData?.user?.name || ""} ${inquiryData?.user?.lastname || ""}`.trim();

      setValue("account_name", customerName || "");
      setValue("destination_wallet_name", inquiryData?.asset?.name || "");
      setInquiryDone(true);
      handleToast("success", response?.data?.message || "استعلام با موفقیت انجام شد");
    } catch (error) {
      setInquiryDone(false);
      setValue("account_name", "");
      setValue("destination_wallet_name", "");
      handleToast(
        "error",
        error?.response?.data?.message || "خطا در استعلام شبا"
      );
    } finally {
      setLoad(false);
    }
  };

  const handleClick = (buttonName) => {
    context.recordClick(buttonName);
  };
  const dataForm = [
    {
      title: "نوع کیف پول",
      registerOption: "two",
      options: {
        required: { value: true, message: "این فیلد اجباری می باشد" },
      },
      type: "select",
      select: assetTypes.map((item) => ({
        id: item.type,
        title: item.title,
      })),
      inputType: "text",
    },

    {
      title: "نام کیف پول",
      registerOption: "one",
      options: {
        required: { value: true, message: "این فیلد اجباری می باشد" },
      },
      type: "select",
      select: filteredWallets.map((item) => ({
        id: item.id,
        title: item.name,
      })),
      inputType: "number",
    },
    {
      title: "شبای کیف پول مقصد",
      registerOption: "four",
      options: {
        required: { value: true, message: "این فیلد اجباری می باشد" },
      },
      type: "input",
      inputType: "text",
    },
    {
      title: "شماره موبایل کیف پول مقصد",
      registerOption: "mobile",
      options: {
        required: { value: true, message: "این فیلد اجباری می باشد" },
        pattern: {
          value: /^9\d{9}$/,
          message: "فرمت شماره موبایل شما نادرست است",
        },
      },
      type: "input",
      placeholder: "شماره موبایل را بدون ۰ وارد کنید",
      inputType: "number",
      hasInquiryButton: true,
    },
    ...(inquiryDone
      ? [
          {
            title: "نام طرف حساب",
            registerOption: "account_name",
            options: {},
            type: "input",
            inputType: "text",
            readOnly: true,
          },
          {
            title: "نام کیف پول مقصد",
            registerOption: "destination_wallet_name",
            options: {},
            type: "input",
            inputType: "text",
            readOnly: true,
          },
        ]
      : []),
    {
      title: "مبلغ(ریال)",
      registerOption: "five",
      options: {
        required: { value: true, message: "این فیلد اجباری می باشد" },
      },
      type: "input",
      inputType: "number",
    },
    {
      title: "کدتایید",
      registerOption: "six",
      options: {
        required: { value: true, message: "این فیلد اجباری می باشد" },
      },
      type: "input",
      inputType: "number",
      btn: true,
    },
  ];
  return (
    <div
      className={`form rounded-2xl shadow p-3 max-w-full md:w-3/4 lg:w-2/4 mx-10 md:mx-auto md:p-3 lg:p-6 ${
        isDark ? "card" : "card2"
      }`}
    >
      <Loading show={load} />
      <ToastContainer />
      <span className=" text-[#0010c6] dark:text-white">کیف به کیف</span>
      <form onSubmit={handleSubmit(onSubmit)} className="mt-3">
        {dataForm.map((item) => {
          return (
            <>
              <label htmlFor="" className="text-xs text-[#0010c6] dark:text-white m-0">
                {item.title}
              </label>
              {item.type == "select" ? (
                <>
                  <select
                    name={item.registerOption}
                    {...register(item.registerOption, item.options)}
                    className={`w-full border rounded-md px-2 py-1 text-xs text-black bg-gray-100 dark:bg-gray-400 dark:text-black font-normal outline-none ${
                      (errors[item.registerOption] &&
                        "bg-red-100 border border-red-400") ||
                      ""
                    }`}
                    id=""
                  >
                    <option value="" hidden>
                      انتخاب کنید
                    </option>
                    {item.select?.map((items) => {
                      return (
                        <option key={items.id} value={items.id}>
                          {items.title}
                        </option>
                      );
                    })}
                  </select>
                  {errors[item.registerOption] && (
                    <p className="text-red-400 text-xs">
                      {errors[item.registerOption].message}
                    </p>
                  )}
                </>
              ) : (
                <div className={`relative `}>
                  {item.registerOption == "five" ? (
                    <Controller
                      control={control}
                      name="five"
                      {...register("five", { required: true })}
                      placeholder={"۰ ریال"}
                      render={({ field: { onChange, name, value } }) => (
                        <NumericFormat
                          className={`w-full border rounded-md px-2 py-1 text-xs text-black bg-gray-100 dark:bg-gray-400 dark:text-black placeholder:text-left font-normal outline-none ${
                            (errors["money"] &&
                              "bg-red-100 border border-red-400") ||
                            ""
                          }`}
                          thousandSeparator=","
                          name={name}
                          value={value}
                          onChange={onChange}
                        />
                      )}
                    />
                  ) : (
                    <div
                      style={
                        item.btn || item.hasInquiryButton
                          ? {
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }
                          : undefined
                      }
                    >
                      <input
                        {...register(item.registerOption, item.options)}
                        placeholder={item.placeholder || ""}
                        type={item.inputType}
                        readOnly={item.readOnly || false}
                        style={
                          item.btn || item.hasInquiryButton
                            ? { flex: 1, minWidth: 0 }
                            : undefined
                        }
                        className={` ${
                          item.btn || item.hasInquiryButton
                            ? ""
                            : "w-full"
                        } border rounded-md px-2 py-1 text-xs text-black bg-gray-100 dark:bg-gray-400 dark:text-black placeholder:text-left font-normal outline-none ${
                          (errors[item.registerOption] &&
                            "bg-red-100 border border-red-400") ||
                          ""
                        } ${
                          item.readOnly
                            ? "cursor-not-allowed bg-gray-200 dark:bg-gray-500"
                            : ""
                        }`}
                      />
                      {item.hasInquiryButton && (
                        <button
                          onClick={handleInquiry}
                          type="button"
                          className="text-center bg-blue-500 px-4 py-1 text-white rounded text-sm whitespace-nowrap"
                        >
                          استعلام
                        </button>
                      )}
                      {item.btn && (
                        <button
                          onClick={handlSendOTP}
                          type="button"
                          disabled={timer > 0}
                          style={{
                            flexShrink: 0,
                            whiteSpace: "nowrap",
                          }}
                          className={`text-center bg-blue-500 px-3 py-1 text-white rounded text-sm ${
                            timer > 0
                              ? "opacity-50 bg-gray-500 text-[10px] cursor-not-allowed"
                              : ""
                          }`}
                        >
                          ارسال کد تایید
                          {timer > 0 && ` (${timer}s)`}
                        </button>
                      )}
                    </div>
                  )}
                  {errors[item.registerOption] && (
                    <p className="text-red-400 text-xs">
                      {errors[item.registerOption].message}
                    </p>
                  )}
                </div>
              )}
            </>
          );
        })}
        <input
          onClick={() => handleClick(`کلیک شد برداشت در  کیف پول ${title}`)}
          type="submit"
          value={"برداشت"}
          className="btn-add text-center mt-3 shadow bg-green-600 cursor-pointer hover:bg-green-700 w-full rounded text-white p-1 text-sm"
        />
      </form>
    </div>
  );
};
